/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropDown, Filter } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { Brand, BrandAdd, BrandChange, BrandTable } from 'models/api/brand';
import ResTable from 'models/api/table';

export const getBrandsList = async (axios: AxiosInstance, params?: Filter<Brand>) => {
    const response = await axios.get<ResTable<BrandTable>>('/brands', { params });
    return response.data;
};

export const getSelectList = async (axios: AxiosInstance) => {
    const response = await axios.get<DropDown[]>('/brands/select-list');
    return response.data;
};

export const getBrandsExcel = async (axios: AxiosInstance, params: Filter<Brand>) => {
    const { data } = await axios.get<Blob>('/brands/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addBrand = async (axios: AxiosInstance, item: BrandAdd) =>
    await axios.post<Brand>('/brands', item);

export const changeBrand = async (axios: AxiosInstance, item: BrandChange) => {
    await axios.put<Brand>(`/brands/${item.id}`, item);
};

export const deleteBrand = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(`/brands/${id}`);

export const getBrand = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<Brand>(`/brands/${id}`);
    return response.data;
};
